export function inr(v) {
  const n = Number(v || 0);
  if (n >= 1e7) return `₹ ${(n / 1e7).toFixed(2)} Cr`;
  if (n >= 1e5) return `₹ ${(n / 1e5).toFixed(2)} L`;
  return `₹ ${n.toLocaleString("en-IN")}`;
}

export function mt(v) {
  return `${Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 1 })} MT`;
}

export function num(v) {
  return Number(v || 0).toLocaleString("en-IN");
}

export function fmtDate(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return s;
  }
}

export function fmtDateTime(s) {
  if (!s) return "—";
  try {
    return new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
  } catch {
    return s;
  }
}

export const TIER_COLORS = {
  Silver: { bg: "#F1F5F9", text: "#475569", ring: "#CBD5E1" },
  Gold: { bg: "#FEF3C7", text: "#B45309", ring: "#FCD34D" },
  Platinum: { bg: "#E0E7FF", text: "#3730A3", ring: "#A5B4FC" },
  Diamond: { bg: "#CFFAFE", text: "#0E7490", ring: "#67E8F9" },
};

export const TEMP_COLORS = {
  Hot: { bg: "#FEE2E2", text: "#DC2626" },
  Warm: { bg: "#FFEDD5", text: "#EA580C" },
  Cold: { bg: "#DBEAFE", text: "#2563EB" },
};
